import React, { useState } from 'react';
import * as RouterDOM from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import v2Theme from './theme/v2Theme';
import { NavBar, Footer, AuthModal } from './components/v2';
import {
  HomePage,
  Dashboard,
  ProfilePage,
  SendPage,
  PayPage,
  AboutPage,
} from './pages/v2';
import { useAuthState } from './utils/useAuthState';

const Router = RouterDOM.BrowserRouter as any;
const Route = RouterDOM.Route as any;
const Switch = RouterDOM.Switch as any;

// Functional component for React.FC + react-router-dom v5 compatibility
const AppV2: React.FC = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const { user, loading } = useAuthState();
  const isAuthenticated = !!user;

  return (
    <ThemeProvider theme={v2Theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <NavBar
            onOpenAuth={() => setAuthModalOpen(true)}
            isAuthenticated={isAuthenticated}
          />

          <Box component="main" sx={{ flex: 1 }}>
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/pay" component={PayPage} />
              <Route exact path="/about" component={AboutPage} />
              <Route exact path="/pay/:coin/:address" component={SendPage} />
              <Route exact path="/:handle/:coin" component={SendPage} />
              <Route exact path="/:handle" component={ProfilePage} />
            </Switch>
          </Box>

          <Footer />

          <AuthModal
            open={authModalOpen}
            onClose={() => setAuthModalOpen(false)}
            onSuccess={() => {
              // Auth state will automatically update via useAuthState hook
              setAuthModalOpen(false);
            }}
          />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default AppV2;
